import { HttpErrorResponse } from "@angular/common/http";
import { AssignedOrganisation } from "src/app/_models/Organisation";
import { SubmitTransferResponse } from "src/app/_models/TransferLearner";
import { Userprofile } from "src/app/_models/Userprofile";

export interface TransferLearnerState {
  loading: boolean;
  loadingTransferCentre: boolean;

  submitTransferResponse: SubmitTransferResponse;
  submitTransferError: HttpErrorResponse;

  learnerDetails: Userprofile;
  learnerDetailsError: HttpErrorResponse;

  assignedOrganisation: AssignedOrganisation[];
  assignedOrganisationError: HttpErrorResponse;

  transferResult: boolean;
  transferError: HttpErrorResponse;

  undoTransferResult: boolean;
  undoTransferError: HttpErrorResponse;
}

export const initialTransferLearnerState: TransferLearnerState = {
  loading: false,
  loadingTransferCentre: false,

  submitTransferResponse: null,
  submitTransferError: null,

  learnerDetails: null,
  learnerDetailsError: null,

  assignedOrganisation: null,
  assignedOrganisationError: null,

  transferResult: false,
  transferError: null,

  undoTransferResult: false,
  undoTransferError: null
};